/** Isolated local testing drafts for the public Agent Ordinary preview.
 * NEVER authenticate or write to Supabase. These are copies only and cannot execute.
 * Canonical imported skills and employee profiles remain immutable.
 */
import type {OwnerSkillDraft,OwnerSkillCandidate} from './unifiedSkillLibrary';
const DRAFT_KEY='agentordinary-preview-local-skill-drafts-v2';
const QUEUE_KEY='agentordinary-preview-local-skill-sources-v2';
const forbidden=/cot-contrarian-detector|contrarian positioning|scrapecreators|comment-mining|competitor-ad-intelligence|competitor-social-research|content-repurposing|influencer-prospecting|outlier-post-finder|product-demand-research|transcript-intelligence|trend-discovery|brand-research|write-video-ad-script|api-tester/i;
function read<T>(key:string,verify:(x:unknown)=>x is T,max:number):T[]{
 try{
  const v=JSON.parse(window.localStorage.getItem(key)||'[]');
  return Array.isArray(v)?v.filter(verify).slice(0,max):[];
 }catch{return []}
}
const isObject=(x:unknown):x is Record<string,unknown>=>typeof x==='object'&&x!==null&&!Array.isArray(x);
function isDraft(x:unknown):x is OwnerSkillDraft{
 return isObject(x)&&typeof x.id==='string'&&x.id.startsWith('skill-')&&x.id.length<=110
  &&typeof x.name==='string'&&x.name.length<=60&&!forbidden.test(x.name)
  &&typeof x.description==='string'&&x.description.length<=240
  &&typeof x.instructions==='string'&&x.instructions.length<=5000
  &&typeof x.category==='string'&&x.category.length<=90
  &&(x.status==='draft'||x.status==='needs review')
  &&Array.isArray(x.assignedTo)&&x.assignedTo.every(a=>typeof a==='string'&&a.length<=90)
  &&typeof x.createdAt==='string';
}
function isCandidate(x:unknown):x is OwnerSkillCandidate{
 return isObject(x)&&typeof x.id==='string'&&x.id.length<=110
  &&typeof x.name==='string'&&x.name.length<=90&&!forbidden.test(x.name)
  &&typeof x.url==='string'&&x.url.length<=1600&&!forbidden.test(x.url)
  &&x.status==='pending review'&&typeof x.notes==='string'&&x.notes.length<=400;
}
export function readPreviewDrafts():OwnerSkillDraft[]{return read(DRAFT_KEY,isDraft,120)}
export function readPreviewQueue():OwnerSkillCandidate[]{return read(QUEUE_KEY,isCandidate,100)}
export function writePreviewDrafts(items:OwnerSkillDraft[]):void{
 if(items.length>120||items.some(x=>!isDraft(x)))throw new Error('Local testing draft is invalid or exceeds the safe limit.');
 try{window.localStorage.setItem(DRAFT_KEY,JSON.stringify(items))}catch{throw new Error('Device storage is unavailable. No draft was saved.')}
}
export function writePreviewQueue(items:OwnerSkillCandidate[]):void{
 if(items.length>100||items.some(x=>!isCandidate(x)))throw new Error('Local source-review list is invalid or exceeds the safe limit.');
 try{window.localStorage.setItem(QUEUE_KEY,JSON.stringify(items))}catch{throw new Error('Device storage is unavailable. No review item was saved.')}
}
